var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":_vm.color,"label":"","outlined":""}},[_vm._v(_vm._s(_vm.$t(_vm.statusLabel)))])}
var staticRenderFns = []

export { render, staticRenderFns }